import React, { useState, useEffect, Fragment } from 'react'
import Navbar from '../../appShell/Navbar/Navbar'
import Sidebar from '../../appShell/Sidebar/Sidebar'
import "./TransmissionChat.css"
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { customFormatDate, customFormatHour, groupBy, handleMenuSelection } from '../../utils/utils';
import ScrollToBottom from "react-scroll-to-bottom";
import { useParams } from 'react-router-dom';
import { addComment, changeNotificationStatus, downloadCommentFile, getNotifications, getTransmissionComments } from '../../services/http';
import useSWR from "swr";
import axios from "axios"
import { BASE_URL, CLIENT_SECRET, CLIENT_ID } from '../../constants/constants';
import { FcPlus } from "react-icons/fc"
import { MdOutlineRemoveCircle } from "react-icons/md"
import commentFile from "../../assets/images/comment_file.svg"
import male_avatar from '../../assets/images/male_avatar.svg'
import female_avatar from '../../assets/images/female_avatar.svg'





const TransmissionChat = (props) => {

    // const { socket, user, transmission } = props;

    // const socket = io.connect("http://localhost:6001");
    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);
    const navigate = useNavigate();
    const id_transmission = useParams();

    const [currentMessage, setCurrentMessage] = useState("");
    const [currentFile, setCurrentFile] = useState([]);
    const [messageList, setMessageList] = useState([]);
    const [participants, setParticipants] = useState([])
    const [transmissionData, setTransmissionData] = useState();
    const [fileExtension, setFileExtension] = useState("");


    const fetcher = (url, token) =>
        axios
            .get(url, { headers: { Authorization: "Bearer " + token } })
            .then((res) => res.data);

    const { data, error } = useSWR(
        [`${BASE_URL}api/comments/${id_transmission?.id_transmission}`, states.userToken.access_token],
        fetcher,
        { refreshInterval: 3000 }
    );

    if (error) { console.log(error) };
    if (data) {
        console.log("Success ", data)

    };
    const downloadFile = async (fileName, id, commentFiles) => {
        console.log("Files Names ", fileName)
        console.log(id)
        console.log("commentFiles ==> ", commentFiles)
        const response = await downloadCommentFile(states.userToken.access_token, id);
        console.log(response)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        if (commentFiles.length === 1) {
            link.setAttribute('download', commentFiles[0]?.filename);
        } else if (commentFiles.length > 1) {
            link.setAttribute('download', fileName + '.zip');
        }
        document.body.appendChild(link);
        link.click();
    }

    function groupArrayOfObjects(list, key) {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };
    
    

    useEffect(() => {
        setTransmissionData(data?.transmission)
        var tempArray = [];
        console.log("Data ==> ", data)
        data?.comment?.map(value => (
            tempArray.push({
                day: customFormatDate(value.created_at),
                data: {
                    id: value.id,
                    message: value.commentaire,
                    commentFiles: value.comment_files,
                    time: customFormatHour(value.created_at),
                    date: customFormatDate(value.created_at),
                    author: value.user.nom,
                    type: typeof value.commentaire
                }
            })))

        // console.log("new Data ", newData)
        const msgList = Object.values(groupArrayOfObjects(tempArray.reverse(), "day"))

        console.log("tempArray.reverse() ", tempArray.reverse())
        console.log("msgList ", msgList)
        console.log("Data ", data)
        setMessageList(msgList);
// To Define participants
        let temp = [];
    let participantsList = [] ;
    temp = Array.from(groupBy(data?.comment, comment => comment?.user?.id).values())
    temp.map(item => 
        participantsList.push({firstName: item[0].user?.prenom, lastName: item[0].user?.nom, sexe: item[0].user?.sexe}))
    setParticipants(participantsList)
    }, [data]);

    var monthArray = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]

    const [launchRequest, setLaunchRequest] = useState(true);

    // To populate the breadcrumb and update the sidebar menu
    useEffect(async () => {
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Transmission", firstLevelLink: "/transmission", secondLevelText: "Commentaires", secondLevelLink: "/transmission-chat", thirdLevelText: "", thirdLevelLink: ""
            }
        });
        handleMenuSelection("transmission", dispatch, states);
    }, [])

    const readNotif = async (idTransmission, idComment) => {
        console.log("Here we are ", id_transmission.id_transmission)
        // console.log(messageList[0][0]?.data?.id)

        const read_comment_response = await changeNotificationStatus(states.userToken.access_token, idTransmission, "comment")
        if (read_comment_response.response && read_comment_response.response.status !== 200) {
            console.log("data error ", read_comment_response.response)
        } else {
            console.log("update comment notif ", read_comment_response)
        }

        const read_alert_response = await changeNotificationStatus(states.userToken.access_token, idTransmission, "alert")
        if (read_alert_response.response && read_alert_response.response.status !== 200) {
            console.log("data error ", read_alert_response.response)
        } else {
            console.log("update alert notif ", read_alert_response)

        }


    }

    useEffect(() => {
        if (messageList?.length != 0) { readNotif(id_transmission?.id_transmission, messageList[0][0]?.data?.id) }
    }, [messageList]);

    const sendMessage = async (type) => {
        console.log("Exec sendMessage")
        if (currentMessage !== "" || currentFile.length !== 0) {
            const messageData = {
                transmission: id_transmission,
                user: states.userInfo?.id,
                commentaire: { message: currentMessage, file: currentFile }
            };

            const res = await addComment(states?.userToken?.access_token, messageData, type)
            if (res.response && res.response.status !== 200) {
                console.log("Top data error ", res.response)
            } else {
                console.log("Top good Data", res.data)
                setCurrentMessage("");
                removeFile()
                // updateNotifList()
            }
        }
    };

    const handleFileChoose = (e) => {
        const value = e.target.files
        console.log("value ", value[0].name)
        if (value.length === 1) {
            let fileName = value[0].name.split(".")
            console.log("FileName ", fileName[fileName.length - 1])
            setFileExtension(fileName[fileName.length - 1])
        }
        let tempArray = [];
        Object.values(value).map(item => tempArray.push(item))
        console.log(tempArray)
        setCurrentFile(tempArray)
    }

    const removeFile = () => {
        setCurrentFile([])
    }

    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing">

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        {/* Chat Start */}

                        {/* <div> */}
                        {/* <div class="chat-system"> */}
                        <div class="widget widget-content widget-content-area p-1 d-flex justify-content-around">
                            {/* <div class="hamburger"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu mail-menu d-lg-none"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg></div> */}
                            <div className="participants-list">
                                <div className='participants-list-header'>
                                    Participants
                                </div>
                                <div className='participants-container'>
                                    {participants.map((participant, index) => (

                                    <div key={index} className="participant-row mb-2 pt-2">
                                      <img src={participant.sexe === "M" ? male_avatar : female_avatar} style={{height: 40, width: 40, marginBottom: 5, textAlign: 'left'}} /> <span style={{color: "#fff"}}><em>{participant.firstName}</em> <b>{participant.lastName}</b></span> 
                                    </div>
                                    ))}
                                   
                                </div>
                            </div>

                            <div className="chat-window">
                                <div className="chat-header">
                                    <p>Commentaires sur la transmission de {monthArray[parseInt(transmissionData?.mois) - 1]} {transmissionData?.annee} </p>

                                </div>
                                <div className="chat-body chat-system">
                                    <ScrollToBottom className="message-container">
                                        {messageList?.map((msg, index) =>
                                            <Fragment key={index + "wmsg"}>
                                                <p className='day'>{msg[0]?.day}</p>
                                                {msg?.map((messageContent, index) =>
                                                    <div
                                                        key={index + "wmsgc"}
                                                        className="message"
                                                        id={states.userInfo?.nom === messageContent.data?.author ? "you" : "other"}
                                                    >
                                                        <div>
                                                            <p id="author">{messageContent.data?.author}</p>
                                                            {/* <div className="message-content">
                                                            {messageContent.data?.message.includes("[object File]") ? <img src={commentFile} onClick={() => downloadFile(`Fichier-${monthArray[parseInt(transmissionData?.mois)]}` + `${transmissionData?.annee}`, messageContent.data?.id)} title="Télécharger" style={{ width: "100px", height: "50px", cursor: "pointer" }} /> : <p>{messageContent.data?.message}</p>}
                                                        </div> */}
                                                            <div className="message-content">
                                                                {messageContent.data.commentFiles?.length !== 0 && <img src={commentFile}
                                                                    onClick={() => downloadFile(`Fichiers-${monthArray[parseInt(transmissionData?.mois) - 1]}` + `-${transmissionData?.annee}`, messageContent.data?.id, messageContent.data.commentFiles)}
                                                                    title="Télécharger"
                                                                    style={{ width: "100px", height: "50px", cursor: "pointer" }} />}
                                                                <p>{messageContent.data?.message}</p>
                                                            </div>
                                                            <div className="message-meta d-flex justify-content-end">
                                                                <p id="time" className=''>{messageContent.data?.date} - {messageContent.data?.time}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Fragment>
                                        )}
                                    </ScrollToBottom>
                                </div>
                                <div className="chat-footer">
                                    <div className="upload-chat-btn-wrapper" style={{ minWidth: currentFile?.length !== 0 ? 170 : "" }}>
                                        {/* {currentMessage == "" && <button class="chat-btn"> {currentFile?.length !== 0 ? <MdOutlineRemoveCircle onClick={removeFile} style={{ color: "red" }} /> : <FcPlus />} </button>} */}
                                        {<button style={{ padding: 7 }} class="chat-btn"> {currentFile?.length !== 0 ? <span className='file-span'> <span className='file-count-span'>{currentFile?.length} fichier(s) </span> <MdOutlineRemoveCircle onClick={removeFile} style={{ color: "red" }} />  </span> : <FcPlus />} </button>}
                                        {currentFile?.length === 0 && <input type="file" name="myfiles" onChange={(e) => handleFileChoose(e)} multiple />}
                                    </div>

                                    <input
                                        // disabled={currentFile?.length !== 0 ? true : false}
                                        type="text"
                                        // value={currentFile?.length !== 0 ? `${currentFile?.length} fichier(s)` : currentMessage}
                                        value={currentMessage}
                                        placeholder="Entrer le message..."
                                        onChange={(event) => {
                                            setCurrentMessage(event.target.value);
                                        }}
                                    // onKeyPress={currentFile?.length !== 0 ? (event) => {
                                    //     event.key === "Enter" && sendMessage("text")
                                    // } : (event) => {
                                    //     sendMessage("files");
                                    // }}
                                    // onKeyPress={(event) => {
                                    //     event.key === "Enter" && sendMessage("text")
                                    // }}
                                    />
                                    <button disabled={currentMessage === "" ? true : false} onClick={currentFile?.length == 0 ? () => sendMessage("text") : () => sendMessage("files")}>&#9658;</button>
                                </div>
                            </div>

                        </div>

                        {/* </div> */}
                        {/* Chat End */}
                    </div>

                </div>
            </div>
        </div>
    )
}

export default TransmissionChat